import React, { useState } from 'react'

import { Tabs, message } from 'antd'

import { observer } from 'mobx-react-lite'

import { trackEvent } from 'common/analytics/event_tracking'
import { Events } from 'common/analytics/events'
import { Card } from 'common/components/Card'
import { Comments } from 'common/components/comments'
import { ErrorBoundary } from 'common/components/ErrorBoundary/error_boundary'
import { OrderHistory } from 'common/components/OrderHistory/history'
import { noticeError } from 'common/helpers/new_relic'
import { SUPPORT_EMAIL_ADDRESS } from 'common/helpers/other'

import { useVendorStores } from 'vendor/hooks/use-stores'

export const MessagesAndHistory = observer(() => {
  const { orderStore } = useVendorStores()

  const [loading, setLoading] = useState(false)
  const [activeKey, setActiveKey] = useState('messages')

  const { comments, company_material_columns = [] } = orderStore.selectedOrder

  return (
    <Card contentProps={{ p: '0 16px 16px 16px' }} minHeight="256px">
      <Tabs
        activeKey={activeKey}
        onChange={async (key) => {
          setActiveKey(key)
          trackEvent(Events.ORDER_HISTORY, location.pathname.substr(1), { clickView: true })
          try {
            setLoading(true)
            await orderStore.getOrderHistory(orderStore.selectedOrder?.id)
          } catch (error) {
            noticeError(error, { entry: 'vendor-order-history' })
            message.error(`Unable to load history. Please contact ${SUPPORT_EMAIL_ADDRESS} for further assistance.`)
          } finally {
            setLoading(false)
          }
        }}
        items={[
          {
            label: 'Messages',
            key: 'messages',
            children: (
              <Comments
                comments={comments}
                onChangeNewComment={orderStore.updateNewComment}
                newComment={orderStore.newComment}
                currentView="VENDOR"
              />
            ),
          },
          {
            label: 'History',
            key: 'history',
            children: (
              <ErrorBoundary isFull={false}>
                <OrderHistory
                  isLoading={loading}
                  data={orderStore.orderHistory}
                  currentView="VENDOR"
                  companyAttributes={company_material_columns.filter((columns) => !['cost_code_id'].includes(columns))}
                />
              </ErrorBoundary>
            ),
          },
        ]}
      />
    </Card>
  )
})
